import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import { LocationUploadRequirementControl } from 'src/components/enterprise/features/Corporate/components/Form/LocationUploadRequirementControl/LocationUploadRequirementControl';
import { DepartmentUploadRequirementControl } from 'src/components/enterprise/features/Corporate/components/Form/DepartmentUploadRequirementControl/DepartmentUploadRequirementControl';
import { useBulkUploadEmployeeWrapper } from 'src/components/enterprise/features/Corporate/components/Form/BulkUploadEmployeeWrapper/hooks/useBulkUploadEmployeeWrapper';

export function BulkUploadEmployeeWrapper(): JSX.Element {
  const { disableRequirementOptions } = useBulkUploadEmployeeWrapper();

  return (
    <Stack>
      <Stack y="x-sm">
        <Copy variant="body" color="secondaryText">
          Bulk Upload Employee Features
        </Copy>
      </Stack>
      <Stack y="xx-sm">
        <LocationUploadRequirementControl
          name="dinerLocationRequired"
          id="dinerLocationRequired"
          disabled={disableRequirementOptions}
        />
      </Stack>
      <Stack y="xx-sm">
        <DepartmentUploadRequirementControl
          name="dinerDepartmentRequired"
          id="dinerDepartmentRequired"
          disabled={disableRequirementOptions}
        />
      </Stack>
    </Stack>
  );
}
